import React from 'react';
import VideoPlayer from './VideoPlayer';

export default function MacBookMockup({ videoUrl }) {
  if (!videoUrl) return null;

  return (
    <div className="px-7 md:px-24 mb-24 md:mb-40 mt-24 md:mt-40 flex justify-center w-full">
      <div className="relative w-full max-w-7xl flex flex-col items-center">

        <div className="relative w-full p-0.5 md:p-0.75 bg-[#66686C] rounded-t-2xl md:rounded-t-[1.75rem] shadow-[0_0_0_1px_rgba(0,0,0,0.1)] z-20 flex flex-col">
          
          <div className="relative w-full bg-black p-2 pb-6 md:p-3 md:pb-8 rounded-t-[calc(1rem-2px)] md:rounded-t-[calc(1.75rem-3px)]">
            
            <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[20%] max-w-40 h-4 md:h-7 bg-black rounded-b-lg md:rounded-b-2xl z-30 flex items-center justify-center pb-1">
              <div className="w-1.5 h-1.5 md:w-2.5 md:h-2.5 bg-[#0A1128] rounded-full border border-white/5 shadow-[inset_0_0_3px_rgba(0,0,0,0.8)]"></div>
            </div>

            <div className="relative w-full aspect-16/10 bg-black rounded-sm md:rounded-lg overflow-hidden ring-1 ring-white/10">
              <VideoPlayer
                src={videoUrl}
                className="absolute inset-0 w-full h-full object-cover rounded-none!"
              />
            </div>
          </div>
        </div>

        <div className="w-[30%] md:w-[30%] h-2 md:h-4 bg-[#141414] rounded-b-lg md:rounded-b-xl -mt-1 z-10 relative shadow-[inset_0_3px_5px_rgba(0,0,0,0.6)]"></div>

        <div className="relative w-[114%] md:w-[110%] -mt-1 md:-mt-3 z-0">
          <div className="w-full h-1.5 md:h-1.5 bg-[#9CA3AF] rounded-t-sm relative border-b border-[#4B5563] shadow-[inset_0_1px_1px_rgba(255,255,255,0.4)]">
            <div className="absolute top-0 left-1/2 -translate-x-1/2 w-16 md:w-28 h-1 md:h-1.5 bg-[#4B5563] rounded-b-md md:rounded-b-lg shadow-[inset_0_1px_2px_rgba(0,0,0,0.5)]"></div>
          </div>
          <div className="w-full h-2 md:h-3.5 bg-linear-to-b from-[#6B7280] to-[#374151] rounded-b-xl md:rounded-b-[2.5rem] shadow-[0_30px_50px_-10px_rgba(0,0,0,0.8)] md:shadow-[0_50px_70px_-15px_rgba(0,0,0,0.9)] relative border-t border-white/10"></div>
        </div>

      </div>
    </div>
  );
}